import { fetchAPI } from '@/shared/lib/api/client';

export interface GameMetaItem {
  id: string;
  short_desc: string;
  rtp: number;
}

export const gamesMetaApi = {
  async getGamesMeta(): Promise<GameMetaItem[]> {
    const { data } = await fetchAPI.get<GameMetaItem[]>('/games/meta');
    return data;
  },
};
